
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/invite/[code]/owner",
      function () {
        return require("private-next-pages/invite/[code]/owner/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/invite/[code]/owner"])
      });
    }
  